import { render, staticRenderFns } from "./CompanySections.vue?vue&type=template&id=7ffa742b"
import script from "./CompanySections.vue?vue&type=script&lang=js"
export * from "./CompanySections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports